import { useLayoutEffect, useRef } from "react";
import LoadingBar, { LoadingBarRef } from "react-top-loading-bar";

export const LazyLoadingBar = () => {
    const ref = useRef<LoadingBarRef>(null);

    useLayoutEffect(() => {
        ref.current?.continuousStart(undefined, 250);

        return () => {
            ref.current?.complete();
        };
    }, []);

    return <LoadingBar ref={ref} color={"#3b227a"} />;
};
